module.exports = __webpack_public_path__ + "static/media/mortgagerent.e14407bb.svg";